// extracted by mini-css-extract-plugin
export default {"rights":"Footer_rights__tunoV","backFooter":"Footer_backFooter__7GFDX","logosSection":"Footer_logosSection__AM33j","logo":"Footer_logo__Gkrq2"};